import { Icon, Typography } from "@fullscript/aviary-web";
import { faStar } from "@fullscript/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./AppRatingRow.styles";

const STAR_POSITIONS = [1, 2, 3, 4, 5];

const AppRatingRow = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.row}>
      <div
        css={styles.stars}
        role="img"
        aria-label={t(l.sideCarousel.slides.mobileApp.starsLabel, {
          value: t(l.sideCarousel.slides.mobileApp.ratingValue),
        })}
      >
        {STAR_POSITIONS.map(position => (
          <Icon key={position} icon={faStar} customCss={styles.star} aria-hidden="true" />
        ))}
      </div>
      <Typography as="span" variant="footnote" fontWeight="bold" intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.mobileApp.ratingValue)}
      </Typography>
      <Typography as="span" variant="footnote" intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.mobileApp.ratingsCount)}
      </Typography>
    </div>
  );
};

export { AppRatingRow };
